<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Länk</div>
            </div>
            <input
                class="form-control"
                required
                readonly
                :value="route('integrations.callmaker.createQuote')"
            />
        </div>

        <p class="small">
            <code>orderId</code> är återförsöksnyckeln. Samma order och samma data returnerar den första offerten utan att skicka meddelanden igen; ändrad data för samma order avvisas.
        </p>

        <p>Använd följande dataformat i JSON:</p>
        <pre><code>
                {
                uuid: "{{ uuid }}", // Must always be this specific value

                name: String,
                phone: String,
                email: String|null, // Optional; maps to customer_email. Invalid email is ignored.
                user: String|null,
                orderId: Number, // Callmaker Order Id
                donorId: String|null, // Optional
                campaignId: String|null, // Optional
                }
            </code></pre>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Mall ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="quoteTemplateId"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Order ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldCallmakerOrderId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Donor ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCallmakerDonorId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Campaign ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCallmakerCampaignId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import { v4 as uuidv4 } from "uuid";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const uuid = ref(null);
const quoteTemplateId = ref(null);
const fieldCallmakerOrderId = ref(null);
const fieldCallmakerDonorId = ref(null);
const fieldCallmakerCampaignId = ref(null);
const serializedValue = computed(() => {
  return {
    uuid: uuid.value,
    quote_template_id: quoteTemplateId.value,
    field_callmaker_order_id: fieldCallmakerOrderId.value,
    field_callmaker_donor_id: fieldCallmakerDonorId.value,
    field_callmaker_campaign_id: fieldCallmakerCampaignId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    uuid.value = modelValue.value.uuid;
    quoteTemplateId.value = modelValue.value.quote_template_id;
    fieldCallmakerOrderId.value = modelValue.value.field_callmaker_order_id;
    fieldCallmakerDonorId.value = modelValue.value.field_callmaker_donor_id;
    fieldCallmakerCampaignId.value = modelValue.value.field_callmaker_campaign_id;
  }
  if (!uuid.value) {
    uuid.value = uuidv4();
  }
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    onUpdate();
  }
}, {
  immediate: true
});
</script>
